if (!customElements.get('product-card')) {
customElements.define(
  'product-card',
  class extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
    }
  
    onSwatchClick(event) {
      const swatch = event.target;
      const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
      const swatchImageElement = swatch.querySelector('.data-variant-image');
      let newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
      let newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;
      if (newImageUrl === null) {
        newImageUrl = swatch ? swatch.getAttribute('src') : null;
        newSrcset = swatch ? swatch.getAttribute('srcset') : null;
      }
      this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
      swatch.classList.add('selected');
  
      if (productImage && newImageUrl) {
        productImage.src = newImageUrl;
        productImage.srcset = newSrcset;
      }
    }
  });
}

function handleProductATCLoader() {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.tagName === 'FORM' && form.closest('ajax-cart-product-form')) {
      const submitButton = form.querySelector('.quick-add__submit');
      const spinner = submitButton?.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
        submitButton.classList.add('loading');
        submitButton.setAttribute('aria-disabled', 'true');
      }
    }
  });

  document.addEventListener('liquid-ajax-cart:request-end', (e) => {
    const { requestState } = e?.detail || {};
    if (requestState?.requestType === 'add') {
      const submitButtons = document.querySelectorAll('.quick-add__submit');
      submitButtons.forEach(button => {
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.add('hidden');
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  handleProductATCLoader();
});